﻿import { lazy } from "../../helpers/lazy";
import GtmService from "../apps/services/gtm.service";
import { handleGtmTracking } from "../apps/utils/API/GTM";

export default class HeaderBanner {
    private SESSIONSTORAGE_PREFIX = 'headerbanner-hidden-';

    private banner: HTMLElement;
    private dismissButton: HTMLButtonElement | null;
    private id: string | undefined;
    private name: string;
    private hidden: boolean;

    constructor(element) {
        this.banner = element;
        this.init();
    }
    
    init = () => {
        this.dismissButton = this.banner.querySelector('button');
        this.id = this.banner.dataset.id;
        this.name = this.banner.dataset.name || '';
        this.hidden = this.getHiddenFromSessionStorage();
        this.initDismissButton();
        this.updateDisplayValue();
        this.setupTracking();
    };
    
    private initDismissButton = () => {
        this.dismissButton?.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.trackDismiss();
            this.dismissBanner();
        });
    };

    private setupTracking = () => {
        if (this.hidden) return;
        this.setupViewPromotionTracking();
        this.setupSelectPromotionTracking();
    };

    private setupViewPromotionTracking = () => {
        lazy(() => this.viewPromotion(), this.banner, true);
    };

    private setupSelectPromotionTracking = () => {
        const links = this.banner.getElementsByTagName('a');
        Array.from(links).forEach((link) => {
            link.addEventListener('click', () => this.selectPromotion(link));
        });
    };

    private viewPromotion = () => {
        GtmService.pushViewPromotionEvent(
            this.id || '',
            this.name,
            false,
            undefined,
            this.name,
            this.name
        );
    };

    private selectPromotion = (link: HTMLAnchorElement) => {
        GtmService.pushSelectPromotionEvent(
            this.id || '',
            this.name,
            false,
            undefined,
            link.href,
            this.name,
            this.name
        );
    };

    private trackDismiss = () => {
        handleGtmTracking({
            event: 'banner_dismiss',
            banner_id: this.id || '',
            banner_name: this.name,
        });
    };

    private updateDisplayValue = () => {
        if (this.hidden && !this.banner.classList.contains('is-hidden')) {
            this.banner.classList.add('is-hidden');
        }    
    };

    private dismissBanner = () => {
        this.hidden = true;
        this.updateDisplayValue();
        this.setHiddenInSessionStorage();
    };
    
    private getHiddenFromSessionStorage = () => {
        return sessionStorage.getItem(this.sessionStorageKey()) === 'true';
    };
    
    private setHiddenInSessionStorage = () =>  {
        sessionStorage.setItem(this.sessionStorageKey(), 'true');
    };

    private sessionStorageKey = () => {
        return this.SESSIONSTORAGE_PREFIX + this.id;
    };
}
